import React from "react";
import { Link } from "react-router-dom";

const HeroBanner = () => {
  return (
    <>
      <section id="home" className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <div className="hero-badge">
              <i className="fas fa-bolt" /> Instant • Secure • Upfront Discount
            </div>
            <h1>
              Recharge &amp; Pay Bills <br />
              with <span style={{ color: "#00477f" }}>FORMAX PAY</span>
            </h1>
            <p>
              Mobile, DTH, Google Play and Utility Bills — instant cashback
              &amp; commission on every transaction. Trusted by thousands.
            </p>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
              <a
                href="https://app.formaxpay.in"
                className="btn-primary"
                style={{ textDecoration: "none" }}
              >
                <i className="fas fa-wallet" /> Access to your account
              </a>

              <a
                href="/services"
                className="btn-secondary"
                style={{
                  background: "white",
                  border: "1px solid #cbd5e1",
                  padding: "12px 28px",
                  borderRadius: 48,
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                Explore Services
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <h3>2L+</h3>
                <p>Active Users</p>
              </div>
              <div className="stat-item">
                <h3>500+</h3>
                <p>Operators</p>
              </div>
              <div className="stat-item">
                <h3>Instant</h3>
                <p>Confirmation</p>
              </div>
            </div>
          </div>
          <div className="hero-illus">
            <img src="/images/hero-banner.png" alt="Hero Illustration" />
          </div>
        </div>
      </section>

      {/* Additional responsive CSS to fix image scaling */}
      <style>{`
        .hero-illus img {
          max-width: 100%;
          height: auto;
          display: block;
        }

        @media (max-width: 850px) {
          .hero-grid {
            flex-direction: column;
            text-align: center;
          }
          .hero-content {
            order: 1;
          }
          .hero-illus {
            order: 0;
            margin-bottom: 24px;
          }
          .hero-illus img {
            max-width: 70%;
            margin: 0 auto;
          }
          .hero-stats {
            justify-content: center;
          }
          .hero-content .btn-primary,
          .hero-content .btn-secondary {
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .hero-illus img {
            max-width: 90%;
          }
          .hero-content h1 {
            font-size: 1.8rem;
          }
        }
      `}</style>
    </>
  );
};

export default HeroBanner;
